import dayjs from 'dayjs'
import { Live } from 'models/live'
import { Timestamp } from 'firebase/firestore'

export interface ResponseLive extends Omit<Live, 'expiryDate'> {
  expiryDate: Timestamp
}

// Get the clear hls endpoint without token from default SVE stream secure
const removeToken = (rawUrl: string): string => {
  const parsed = new URL(rawUrl)
  const outPath = parsed.pathname.slice(parsed.pathname.indexOf('/out'))

  // return Origin + path + search params
  // eg: https://channel-xxxx.live.candidate.sportall.media/out/v1/xxxx/index.m3u8?start=xxxx
  return `${parsed.origin}${outPath}${parsed.search}`
}

const getLiveUrl = async ({ expiryDate, ...data }: ResponseLive) => {
  if (!data.spekeSignature) {
    return {
      ...data,
      expiryDate: expiryDate.toDate().toString(),
    }
  }

  // fetch m3u8 endpoint and if its ok than return, otherwise propagate cloudfront signature
  const m3u8Endpoint = await fetch(data.url)
    .then((res) => {
      if (res.status !== 200) {
        const removedTokenUrl = removeToken(data.url)
        const url = new URL(removedTokenUrl)

        url.searchParams.set('Policy', data?.spekeSignature?.policy || '')
        url.searchParams.set(
          'Key-Pair-Id',
          data?.spekeSignature?.keyPairId || '',
        )
        url.searchParams.set('Signature', data?.spekeSignature?.signature || '')
        return url.toString()
      }
      return data.url
    })
    .catch(() => data.url)

  return {
    ...data,
    expiryDate: expiryDate.toDate().toString(),
    url: m3u8Endpoint,
  }
}

export const transformLives = async (
  lives: ResponseLive[],
): Promise<Live[]> => {
  const transformedLives = await Promise.all(lives.map(getLiveUrl))

  return transformedLives.filter((live) => {
    if (!live?.published) return false
    if (!live.expiryDate) return true
    return dayjs().isSameOrBefore(dayjs(live.expiryDate, 'YYYY-MM-DD HH:mm'))
  })
}
